import { PRIVILEGES } from 'constants/privileges';

export const reportsPrivileges = [
  PRIVILEGES.Reports.VIEW_ACTIVITY_REPORT,
  PRIVILEGES.Reports.VIEW_CONTAINERS_REPORT,
  PRIVILEGES.Reports.VIEW_FORECAST,
  PRIVILEGES.Reports.VIEW_INVOICES_REPORT,
  PRIVILEGES.Reports.VIEW_JOB_REPORT,
  PRIVILEGES.Reports.VIEW_OFFERS_REPORT,
];
